"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuneScapePanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const osrs_sdk_1 = require("osrs-sdk");
const SpriteFrame_1 = require("./SpriteFrame");
function RuneScapePanel({ children, className, style, ...props }) {
    return ((0, jsx_runtime_1.jsx)(SpriteFrame_1.SpriteFrame, { ...props, assets: { middle: osrs_sdk_1.INTERFACE_ASSETS.dialog.background, ...osrs_sdk_1.INTERFACE_ASSETS.dialog }, className: ["osrs-ui-panel", className].filter(Boolean).join(" "), overlapFrame: true, slice: 32, style: { color: "#ff981f", padding: 32, textShadow: "1px 1px #000", ...style }, children: children }));
}
exports.RuneScapePanel = RuneScapePanel;
